import DarkModeIcon from '@mui/icons-material/DarkMode';
import SecurityIcon from '@mui/icons-material/Security';
import {
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  Grid,
  useColorScheme,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';
import { Can } from 'core/components/permissions/Can';
import CardedPage from 'layout/pages/CardedPage';
import { isNil } from 'lodash-es';
import MangoIntegrationSettings from './MangoIntegrationSettings';
import ModulesSettings from './ModulesSettings';

export default function SettingsPage(): JSX.Element {
  const { mode, setMode } = useColorScheme();

  return (
    <CardedPage title='Настройки'>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography variant='h6'>Общие настройки</Typography>
          <Divider sx={{ my: 2 }} />

          <List>
            {!isNil(mode) && (
              <ListItem>
                <ListItemIcon>
                  <DarkModeIcon />
                </ListItemIcon>
                <ListItemText
                  primary='Тема'
                  secondary='Переключить тему интерфейса'
                  slotProps={{
                    primary: {
                      id: 'theme-toggle',
                    },
                  }}
                />
                <FormControl>
                  <Select
                    aria-labelledby='theme-toggle'
                    name='theme-toggle'
                    size='small'
                    value={mode}
                    sx={{ width: 130 }}
                    onChange={(event) => {
                      setMode(event.target.value as 'system' | 'light' | 'dark');
                    }}>
                    <MenuItem value='system'>Системная</MenuItem>
                    <MenuItem value='light'>Светлая</MenuItem>
                    <MenuItem value='dark'>Темная</MenuItem>
                  </Select>
                </FormControl>
              </ListItem>
            )}
          </List>
        </Grid>

        <Can I='read' a='ShopModules'>
          <Grid item xs={12}>
            <ModulesSettings />
          </Grid>
        </Can>

        <Can I='read' a='MangoIntegration'>
          <Grid item xs={12}>
            <MangoIntegrationSettings />
          </Grid>
        </Can>

        <Grid item xs={12}>
          <Typography variant='h6'>Безопасность</Typography>
          <Divider sx={{ my: 2 }} />

          <List>
            <ListItem>
              <ListItemIcon>
                <SecurityIcon />
              </ListItemIcon>
              <ListItemText
                primary='Изменить пароль'
                secondary='Обновите свой пароль для повышения безопасности'
              />
              <Button variant='outlined' size='small' disabled>
                Изменить
              </Button>
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </CardedPage>
  );
}
